import React, { useMemo, useState } from 'react';
import * as S from './styles';
import { DependencyManagerProvider } from 'src/contexts/dependencyManager';
import { ShellProvider } from 'src/contexts/shellContext'; // Add this import
import * as T from './types';
import UpgradeRootComponent from 'src/components/UpgradeRootComponent/UpgradeRootComponent';
import { createApolloClient } from 'src/services/ApolloClient';
import { ApolloProvider } from '@apollo/client';
import { DataProvider } from 'src/contexts/DataContext';

// This file is your main component, it's the one that will be rendered by default.
// We recommend to create small components inside the components folder
// and import them here based on your need to make this file easier to understand.
const AppComponent: React.FC<T.AppPropsType> = ({ properties }) => {
  return (
    <S.Container>
      <UpgradeRootComponent />
    </S.Container>
  );
};

// This component wraps your main component with the DependencyManagerProvider
// This provider is responsible to manage global dependencies to your component
const App: React.FC<T.AppPropsType> = (props) => {
  const [authToken, setAuthToken] = useState<string>('');
  props?.authProvider?.getAccessToken().then((res) => {
    setAuthToken(res);
  });
  const graphqlClient = useMemo(
    () => createApolloClient(authToken, props?.stack),
    [props?.authProvider, props?.stack, authToken]
  );
  return (
    <DependencyManagerProvider>
      <ShellProvider value={props}>
        <ApolloProvider client={graphqlClient}>
          <DataProvider>
            <AppComponent {...props} />
          </DataProvider>
        </ApolloProvider>
      </ShellProvider>
    </DependencyManagerProvider>
  );
};

export default App;
